import { Search } from '@shared/components/ui/Search';
import { FilterConditionOutput } from '@components/ui/AdvancedFilter';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface FiltersSectionProps {
  handleSearch: (searchTerm: string) => void;
  onFilterChange?: (conditions: FilterConditionOutput[]) => void;
}

export const FiltersSection = ({ handleSearch, onFilterChange }: FiltersSectionProps) => {
  const { t } = useTranslation('reusedModule');
  const [inputValue, setInputValue] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSearchSubmit = useCallback(() => {
    const trimmedValue = inputValue.trim();
    handleSearch(trimmedValue);
  }, [inputValue, handleSearch]);

  return (
    <div className="flex items-center gap-3">
      <Search
        placeholder={t('search.placeholder', 'Buscar recepciones...')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="search"
        inputDataTestId="search-input"
      />
    </div>
  );
};
